// extracted by mini-css-extract-plugin
export default {"modal":"OR-z","error":"PR-z","disabled":"QR-z","fields":"RR-z","errorMsg":"SR-z","footer":"TR-z","formContentWrapper":"UR-z","productImage":"VR-z","overlay":"WR-z"};